import { createFileRoute, notFound } from '@tanstack/react-router';

import { buildGuards, hasPermission } from '@mint-lib/routing-guards';
import { z } from 'zod';

const guard = buildGuards(
  hasPermission('insertionOrderFeature:view'),
  hasPermission('campaignPlanningFeature:view'),
  hasPermission('financialDataFeature:view'),
);

export const Route = createFileRoute(
  '/_secured/campaign/$campaignId/planning/insertion-orders',
)({
  validateSearch: z.object({
    id: z.number().optional(),
    mediaplan: z.number().optional(),
  }),
  async beforeLoad({ context }) {
    const guardsContext = await context.getGuardContext(
      await context.getInstance('flagsmith', '@myn/secured'),
    );
    if (!guard(guardsContext)) {
      throw notFound();
    }
  },
  loader: async ({ context }) => {
    const i18n = await context.getInstance('i18n', '@mint/routing');
    await context.getInstance('i18n', '@myn/insertion-orders');
    const title = i18n.t('Insertion Orders | MINT');
    return { title };
  },
  head: ({ loaderData }) => ({
    meta: [
      {
        title: loaderData?.title,
      },
    ],
  }),
});
